import React from 'react';

import { Stack, Box } from '@mui/material';
import { useIntersectionObserver } from 'usehooks-ts';
import { MasteryHeatMapYAxisLabels, AxisLabel } from './MasteryHeatMapYAxisLabels';
import { MasteryHeatMapGridItem } from './MasteryHeatMapGridItem';
import { getPast40WeeksDatesGroupedByMonths, convertToArraysOfFiveItems } from '../utils';
import { type StudentDayStats } from '../../model';

const GRID_ITEM_GAP = '6px';

type Props = {
  data: Record<string, StudentDayStats> | undefined;
};

export const MasteryHeatMapGrid = ({ data }: Props) => {
  const months = getPast40WeeksDatesGroupedByMonths();

  const { isIntersecting, ref } = useIntersectionObserver({
    threshold: 0.5,
    freezeOnceVisible: true,
  });

  return (
    <Stack direction="row" spacing={GRID_ITEM_GAP} mt={5} overflow="auto" ref={ref}>
      <Stack spacing={GRID_ITEM_GAP} pr={1.25}>
        <MasteryHeatMapYAxisLabels />
      </Stack>
      {months.map((month, i) => {
        const weeks = convertToArraysOfFiveItems(month.days);
        const hideMonthLabel = i === 0 && weeks.length <= 1;

        return (
          <Stack key={`month_grid_${i}`} justifyContent="flex-end">
            <Box sx={{ height: '32px' }}>
              <AxisLabel textAlign="left">{hideMonthLabel ? '' : month.month}</AxisLabel>
            </Box>
            <Stack direction="row" spacing={GRID_ITEM_GAP}>
              {weeks.map((week, i) => (
                <Stack spacing={GRID_ITEM_GAP} key={`week_col_${i}`}>
                  {week.map((date) => (
                    <MasteryHeatMapGridItem
                      key={date}
                      date={date}
                      mastered={data?.[date]?.actual ?? 0}
                      isIntersecting={isIntersecting}
                    />
                  ))}
                </Stack>
              ))}
            </Stack>
          </Stack>
        );
      })}
    </Stack>
  );
};
